import React from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Container,
    useTheme,
} from "@mui/material";
import { motion } from "framer-motion";


const articles = [
    {
        title: "Customer First Approach.",
        desc: "Thousands of users trust us for managing their finances securely....",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/trusted",
    },
    {
        title: "24x7 Support",
        desc: "Dedicated customer support round the clock for your needs....",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/24*7",
    },
    {
        title: "Secure & Reliable",
        desc: "We ensure data privacy and use bank-level encryption....",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/secure",
    },
];

const WhyUs = () => {
    const theme = useTheme();
    const MotionBox = motion(Box);

    return (
        <Box sx={{ py: { xs: 5, md: 4 } }}>
            <Container maxWidth="lg">

                {/* HEADER */}
                <Box sx={{ mb: { xs: 3, md: 4 } }}>
                    <Typography
                        sx={{
                            fontSize: "13px",
                            letterSpacing: "1.5px",
                            fontWeight: 600,
                            mb: 1,
                            color: theme.palette.primary.main,
                        }}
                        data-aos="fade-right"
                    >
                        • OUR EDGE
                    </Typography>


                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "28px", md: "40px" },
                            fontWeight: 600,
                            color: theme.palette.text.primary,
                            position: "relative",
                            display: "inline-block",
                        }}
                    >
                        Why Government Employees Trust{" "}
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 900,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                position: "relative",
                                display: "inline-block",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: "-4px",
                                    left: 0,
                                    width: "100%",
                                    height: "2px",
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                }
                            }}
                        >
                            ArthGyan
                        </Box>{" "}
                        {/* Different

                         ArthGyan */}
                    </Typography>





                </Box>


                <MotionBox
                    initial={{ y: 80, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "1fr 1fr",
                            md: "1fr 1fr 1fr",
                        },
                        gap: { xs: 2.5, md: 3 },
                    }}
                >

                    {articles.map((item, index) => (
                        <Card
                            key={index}
                            elevation={0}
                            sx={{
                                position: "relative",
                                height: "100%",
                                borderRadius: "18px",
                                background: "#ffffff",
                                border: "1px solid #e5edf5",
                                overflow: "hidden",
                                transition: "all 0.3s ease",

                                "&:hover": {
                                    transform: "translateY(-6px)",
                                    borderColor: theme.palette.primary.main,
                                    boxShadow: `0 16px 35px ${theme.palette.primary.main}18`,
                                },

                                "&:hover .whyus-image": {
                                    transform: "scale(1.05)",
                                },

                                "&:hover .whyus-number": {
                                    backgroundColor: theme.palette.primary.main,
                                    color: "#ffffff",
                                },
                            }}
                        >
                            {/* Image section */}
                            <Box
                                sx={{
                                    position: "relative",
                                    p: 1.5,
                                    pb: 0,
                                }}
                            >
                                <Box
                                    sx={{
                                        height: { xs: 175, md: 190 },
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                        backgroundColor: "#f0f6ff",
                                    }}
                                >
                                    <Box
                                        className="whyus-image"
                                        component="img"
                                        src={item.img}
                                        alt={item.title}
                                        loading="lazy"
                                        sx={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block",
                                            transition: "transform 0.5s ease",
                                        }}
                                    />
                                </Box>

                                {/* Number badge */}
                                <Box
                                    className="whyus-number"
                                    sx={{
                                        position: "absolute",
                                        bottom: -16,
                                        right: 28,
                                        width: 38,
                                        height: 38,
                                        borderRadius: "12px",
                                        backgroundColor: "#eaf4ff",
                                        color: theme.palette.primary.main,
                                        border: "3px solid #ffffff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: 12,
                                        fontWeight: 800,
                                        transition: "all 0.3s ease",
                                    }}
                                >
                                    0{index + 1}
                                </Box>
                            </Box>

                            {/* Content section */}
                            <CardContent
                                sx={{
                                    p: { xs: 2.5, md: 3 },
                                    pt: 3,
                                    "&:last-child": {
                                        pb: 3,
                                    },
                                }}
                            >
                                {/* Accent line */}
                                <Box
                                    sx={{
                                        width: 34,
                                        height: 3,
                                        borderRadius: 5,
                                        mb: 1.8,
                                        background:
                                            "linear-gradient(90deg, #007bff, #00a8a8)",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        fontSize: 16,
                                        fontWeight: 700,
                                        mb: 1,
                                        color: theme.palette.text.primary,
                                        lineHeight: 1.5,
                                    }}
                                >
                                    {item.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: 13,
                                        lineHeight: 1.8,
                                        color: theme.palette.text.secondary,
                                    }}
                                >
                                    {item.desc}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}

                </MotionBox>

            </Container>
        </Box>
    );


};

export default WhyUs;
